export enum PaymentFrequency {
  Annually = 'annually',
  Annual = 'Annual',
  Monthly = 'monthly',
  Prepay = 'prepay',
  AnnualPrepay = 'annualPrepay',
}
